export const menus = [
  {
    key: 'rich-menu',
    name: 'Rich Menu',
    path: '/rich-menu',
  },
  {
    key: 'tracking-log',
    name: 'Tracking Log',
    path: '/tracking-log',
  },
  {
    key: 'pc-segment',
    name: 'PC Segment',
    path: '/pc-segment',
  },
  {
    key: 'user-management',
    name: 'User Management',
    path: '/user-management',
  },
]
